<template>
  <v-main class="pa-7 h-100">
    <v-container class="grey lighten-5 pa-5 h-100">
      <div class="d-flex flex-column justify-space-between h-100">
        <div class="grow">
          <v-simple-table v-if="false">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>{{ file.name }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <div class="shrink">
          <div class="d-flex justify-space-between align-center">
            <v-card class="pa-2 grow mr-5" tile>
              <p v-if="file.name" class="ma-0">
                {{ file.name }}
              </p>
              <p v-else class="ma-0">File Name</p>
            </v-card>
            <form enctype="multipart/form-data">
              <input
                ref="uploadRef"
                type="file"
                @change="fileSelected"
                v-show="false"
              />
            </form>
            <v-btn @click="selectFile" elevation="2"> Upload </v-btn>
          </div>
        </div>
      </div>
    </v-container>
  </v-main>
</template>
<script>
export default {
  name: "SimpleUpload",
  data() {
    return {
      file: "",
    };
  },
  created() {},
  methods: {
    selectFile() {
      const ref = this.$refs.uploadRef;
      ref.click();
    },
    fileSelected() {
      this.file = this.$refs.uploadRef.files[0];
    },
  },
};
</script>
